import React from 'react';
import {
  Slot as RadixSlot,
  Slottable as RadixSlottable,
} from '@radix-ui/themes';
import type { RadixSlotProps, RadixSlottableProps } from '@/types/radix-ui';

/**
 * Slot and Slottable components - wrappers around Radix UI Slot components
 * Provides composition utilities for building flexible component APIs
 */

export type SlotProps = RadixSlotProps;
export type SlottableProps = RadixSlottableProps;

const Slot: React.FC<SlotProps> = props => {
  return <RadixSlot {...props} />;
};

const Slottable: React.FC<SlottableProps> = props => {
  return <RadixSlottable {...props} />;
};

Slot.displayName = 'Slot';
Slottable.displayName = 'Slottable';

export { Slot, Slottable };
